const utils = require('analytics/utils');
const locationUtils = require('utils/Location');
const anaConsts = require('analytics/constants');
const deepExtend = require('utils/deepExtend');

module.exports = function (data) {
    const currentEvent = utils.getMostRecentEvent(
        anaConsts.LINK_TRACKING_EVENT
    );
    const isCCApplyPage = locationUtils.isCreditCardApplyPage();
    const rootContainerName = data.sku.rootContainerName || data.analyticsData.rootContainerName;
    const isNotUseItWith = rootContainerName?.toLowerCase() !== anaConsts.CONTEXT.USE_IT_WITH;
    let linkName = `Add To Basket${data.analyticsData.isPickup ? ' For Store Pickup' : data.analyticsData.isSameDay ? ' For Same Day Delivery' : ''}`;
    linkName = data.analyticsData.isSameDay ? linkName.toLowerCase() : linkName;
    let actionInfoData = rootContainerName && !data.analyticsData.isBIRBPageRewardModal && isNotUseItWith
        ? data.context !== anaConsts.CONTEXT.QUICK_LOOK 
            ? `${rootContainerName}:add to basket`
            : 'add to basket'
        : linkName;

    const isCustomSet = data?.sku?.configurableOptions && isNotUseItWith;
    actionInfoData = isCustomSet ? anaConsts.LinkData.ADD_TO_BASKET_CUSTOM_SET : actionInfoData;
    actionInfoData = data.analyticsData.isGiftCardQuickAdd ? `${anaConsts.LinkData.GIFT_CARD}:${anaConsts.ACTION_INFO.ADD_TO_BASKET}` 
        : actionInfoData;

    let attributes = {
        linkName: data.analyticsData.isAddFullSize ? 'Add Full Size' : isCustomSet ? anaConsts.LinkData.ADD_TO_BASKET_CUSTOM_SET :
            linkName,
        actionInfo: actionInfoData,
        eventStrings: isCCApplyPage ? [anaConsts.Event.SC_ADD] :
            [anaConsts.Event.EVENT_71, anaConsts.Event.SC_ADD],
        biRewardType: data.sku.biType,
        skuId: data.sku.skuId
    };

    if (data.analyticsData.origin) {
        attributes.actionInfo = `${data.analyticsData.origin}:add to basket`;
    }

    if (data.previousPage && data.previousPage.includes('basket')) {
        attributes.actionInfo = 'add to basket';
    }

    const currentProductStrings = currentEvent.eventInfo.attributes.productStrings;

    if (locationUtils.isGalleryPage()) {
        const newProductStrings = `${currentProductStrings}|eVar72=${anaConsts.PAGE_TYPES.COMMUNITY}:${anaConsts.PRODUCT_TAGGING_PLATFORMS.GALLERY}:product-tag`;
        attributes.productStrings = newProductStrings;
    }

    /* ILLUPH-119839
     * According to JIRA and business, requirement is to have prop55 populate with
     * actionCampaignString listed below only for the products within the
     * loves, purchases, and services carousels on the profile lists page.
     * On other pages we will continue to populate eVar75 with actionCampaignString.
    */
    if (rootContainerName) {
        let productId = data.sku.productId || data.analyticsData.productId;
        if (rootContainerName === anaConsts.CAROUSEL_NAMES.LOVES ||
            rootContainerName === anaConsts.CAROUSEL_NAMES.PURCHASES ||
            rootContainerName === anaConsts.CAROUSEL_NAMES.SERVICES ||
            rootContainerName === anaConsts.CAROUSEL_NAMES.USER_PROFILE) {
            if (data.analyticsData.isAddFullSize) {
                attributes.actionInfo = `${rootContainerName}:${productId}:add full size`;
            } else {
                attributes.actionInfo = `${rootContainerName}:Add To Basket`;
            }
        } else {
            attributes.internalCampaign = `${rootContainerName}:${productId}:add-to-basket`;
        }
    }

    // UTS-1071 Fix for pageDetail
    if (data.pageName && typeof data.pageDetail === 'undefined') {
        attributes.pageDetail = data.pageName.split(':')[1];
    }

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: attributes
        }
    });
};
